import {
  FETCH_LATEST_GANGSTERS_REQUEST,
  FETCH_LATEST_GANGSTERS_RECIEVED,
  FETCH_LATEST_GANGSTERS_FAIL,
  FETCH_LATEST_MINTED_GANGSTERS_REQUEST,
  FETCH_LATEST_MINTED_GANGSTERS_RECIEVED,
  FETCH_LATEST_MINTED_GANGSTERS_FAIL,
} from "../actions/home.js";

const defaultState = {
  isUpdatedGangstersLoading: false,
  isMintedGangstersLoading: false,
  updatedGangstersData: [],
  mintedGangstersData: [],
  fetchUpdatedGangstersError: "",
  fetchMintedGangstersError: "",
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_LATEST_GANGSTERS_REQUEST:
      return {
        ...state,
        isUpdatedGangstersLoading: true,
        fetchUpdatedGangstersError: "",
      };

    case FETCH_LATEST_GANGSTERS_RECIEVED:
      return {
        ...state,
        updatedGangstersData: action.data,
        isUpdatedGangstersLoading: false,
        fetchUpdatedGangstersError: "",
      };

    case FETCH_LATEST_GANGSTERS_FAIL:
      return {
        ...state,
        fetchUpdatedGangstersError: action.error,
        isUpdatedGangstersLoading: false,
      };

    case FETCH_LATEST_MINTED_GANGSTERS_REQUEST:
      return {
        ...state,
        fetchMintedGangstersError: "",
        isMintedGangstersLoading: true,
      };

    case FETCH_LATEST_MINTED_GANGSTERS_RECIEVED:
      return {
        ...state,
        mintedGangstersData: action.data,
        isMintedGangstersLoading: false,
      };

    case FETCH_LATEST_MINTED_GANGSTERS_FAIL:
      return {
        ...state,
        fetchUpdatedGangstersError: action.error,
        isMintedGangstersLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
